module.exports = __webpack_public_path__ + "img/partner18.13bd8af8.png";